;(function (w, d) {

  gsap.registerPlugin(ScrollToPlugin)

  const scNavList = d.getElementsByClassName('csNav');

  function pinSecondaryNav() {

    ScrollTrigger.create({
      trigger: '#caseStudyNav',
      pin: true,
      pinSpacing: false,
      start: "top top",
      end: "bottom top",
      endTrigger: "document",
      toggleClass: 'pinned'
    })

  }

  function scrollToSection() {

    const scrollLinks = d.getElementsByClassName('csNav');

    for (let i = 0; i < scrollLinks.length; i++) {

      const id = scrollLinks[i].getAttribute("href");

      this["scrollScene" + i] = ScrollTrigger.create({
        trigger: id,
        start: "top 300px",
        end: "bottom top",
        duration: "100%",
        onEnter: () => {
          for (let j = 0; j < scrollLinks.length; j++) {
            if (scrollLinks[j] !== scrollLinks[i]) {
              scrollLinks[j].classList.remove('current');
            }
          }

          scrollLinks[i].classList.add('current');
        },
        onEnterBack: () => {
          for (let j = 0; j < scrollLinks.length; j++) {
            if (scrollLinks[j] !== scrollLinks[i]) {
              scrollLinks[j].classList.remove('current');
            }
          }

          scrollLinks[i].classList.add('current');
        },
        onLeave: () => {
          scrollLinks[i].classList.remove('current');
        },
        onLeaveBack: () => {
          scrollLinks[i].classList.remove('current');
        }
      });

      scrollLinks[i].addEventListener('click', function (e) {

        if (id.length > 0) {
          e.preventDefault();
          gsap.to(window, {duration: 1.2, scrollTo: id})
        }
      });

    }

  }

  function initTextScrambler() {

    const scrambleList = d.getElementsByClassName('scrambleText')

    for (let i = 0; i < scrambleList.length; i++) {

      const element = scrambleList[i],
        text = element.dataset.scrambleTo
      ;

      gsap.to(element, 3, {scrambleText: {text: text, chars: "123456", speed: 0.5}, scrollTrigger:'#sm__caseNumbers'});
    }

  }

  function initTornadoFunction(container) {
    /**
     * Tornado function will take all children elements of the container element and position so that they are in a 3d cylinder and spin slowly in a twister style
     */
    const debris = container.querySelectorAll('.bCard:not(.starterCard)')

    const explosionTL = gsap.timeline({
      paused: true,
      once:true,
      onComplete: () => {

        function initWind() {

          let wind = gsap.timeline({
            repeat: -1, yoyo: true, ease: 'linear'
          });

          wind.to(debris, 8, getWindMovement());

          w.addEventListener('resize', function (e) {
            wind.invalidate();
            wind.play();
          });
        }

        initWind();

      }
    })
    ;

    const explosionStart = {
      xPercent: [-170, -140, 30, 47],
      yPercent: [50, -98, -134, 15],
      rotationX: [6, 10, 2, 15],
      rotationY: [4, 5, 1, 12],
      rotation: [2, -3, 1, -5],
      z: [-300, -100, -300, -100]
    }

    explosionTL.to(
      debris, 1.2,
      {
        scale: 1,
        ease: 'power4.out',
        xPercent: (index) => {
          return explosionStart.xPercent[index]
        },
        yPercent: (index) => {
          return explosionStart.yPercent[index]
        },
        rotationX: (index) => {
          return explosionStart.rotationX[index]
        },
        rotationY: (index) => {
          return explosionStart.rotationY[index]
        },
        rotation: (index) => {
          return explosionStart.rotation[index]
        },
        z: (index) => {
          return explosionStart.z[index]
        },
        stagger: {
          amount: 0.3
        }
      })

    function getWindMovement() {

      let movement = {
        ease: Power2.easeInOut,
        stagger: .5
      };

      function createRandomValues(startValues) {

        const add = Math.round(Math.random()) === 1 ? true : false;

        return startValues.map(function (x) {
          return add === true ?
            x + Math.floor(Math.random() * 2) :
            x - Math.floor(Math.random() * 2);
        });

      }

      movement.rotationY = createRandomValues(explosionStart.rotationY);
      movement.rotationX = createRandomValues(explosionStart.rotationX);
      movement.rotation = createRandomValues(explosionStart.rotation);

      return movement;

    }

    ScrollTrigger.create({
      trigger: '#tornado',
      start: "top 66%",
      end: "bottom top",
      onEnter: ({}) => {
        explosionTL.play();
      }
    })

  }

  function initBeforeAfterSliders() {

    const sliders = d.querySelectorAll('[data-before-after-slider]');

    for (let i = 0; i < sliders.length; i++) {

      const slider = sliders[i],
        range = slider.querySelector('.beforeAfterSlider__range')
      ;

      if (!range) {
        continue;
      }

      function updateSlider() {
        slider.style.setProperty('--slider-position', range.value + '%');
      }

      range.addEventListener('input', updateSlider);
      range.addEventListener('change', updateSlider);

      updateSlider();

    }

  }

  w.addEventListener('DOMContentLoaded', function (e) {

    pinSecondaryNav();

    scrollToSection();

    initTextScrambler();

    initBeforeAfterSliders();

    const bCardTornado = d.getElementById('tornado');
    if (bCardTornado) {
      initTornadoFunction(bCardTornado);
    }

  })

})(window, document);
